import { useCallback } from 'react';

import { SendVerificationCode } from '#src/components/settings/PhoneNumberVerification/SendVerificationCode/index.tsx';
import { useVerifyPhoneNumber } from '#src/components/user/VerifyPhoneNumber/useVerifyPhoneNumber.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

type Props = {
  onSuccess: (phoneNumber: string) => void;
};

export const AddPhoneNumber = ({ onSuccess }: Props) => {
  const { currentUser } = useCurrentUserContext();

  const verifyPhoneNumber = useVerifyPhoneNumber();

  const sendVerificationCode = useCallback(
    async (phoneNumber: string) =>
      verifyPhoneNumber(phoneNumber).then(async res => {
        return Promise.resolve(res || []);
      }),
    [verifyPhoneNumber]
  );

  if (!currentUser) return null;

  return (
    <SendVerificationCode
      sendVerificationCode={sendVerificationCode}
      onSuccess={onSuccess}
    />
  );
};
